import { Flex, Text } from '@chakra-ui/react';
import Content from './components/content';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from './components/ui/button';

export function UnknownRoutePage() {
    const navigate = useNavigate();

    return (
        <Content headerTitle="Page not found">
            {{
                content: (
                    <Flex
                        justifyContent="center"
                        alignItems="center"
                        h="100%"
                        w="100%"
                        flexDirection="column"
                        gap="16px"
                        textAlign="center">
                        <Text fontSize="24px" fontWeight="bold">
                            404 - Page Not Found
                        </Text>
                        <Text fontSize="16px" maxW="400px">
                            Sorry, the page you're looking for doesn't exist. It may have been moved or the link might be broken.
                        </Text>
                        <Button as={Link} colorScheme="teal" variant="solid" onClick={() => navigate('/')} size="md">
                            Go to Home Page
                        </Button>
                    </Flex>
                ),
            }}
        </Content>
    );
}
